export default __webpack_public_path__ + "static/media/Travel.3e9ac1e8.svg";